
/**
 * Verifica si el navegador es Chrome o iOS y agrega una clase al body su respectivo clase
 */
function updatePositionOnTextOnChrome() {
    if(checkIsChrome()){
        setFlagIsChrome();
    }else{
        if (checkIsIOS()) {
            setFlagIsIOS();
        } else if(checkIsSafari()) {
            setFlagIsSafari();
        } else if(checkIsFirefox()){
            setFlagIsFirefox();
        } else{
            setFlagIsNotChrome();
        }
    }
}

function checkIsChrome() {
    // please note, 
    // that IE11 now returns undefined again for window.chrome
    // and new Opera 30 outputs true for window.chrome
    // but needs to check if window.opr is not undefined
    // and new IE Edge outputs to true now for window.chrome
    // and if not iOS Chrome check
    // so use the below updated condition
    let isChromium = window.chrome;
    let winNav = window.navigator;
    let vendorName = winNav.vendor;
    let isOpera = typeof window.opr !== "undefined";
    let isIEedge = winNav.userAgent.indexOf("Edg") > -1;
    let isIOSChrome = winNav.userAgent.match("CriOS");

    if (isIOSChrome) {
        // is Google Chrome on IOS
        return false;
    } else if(
        isChromium !== null &&
        typeof isChromium !== "undefined" &&
        vendorName === "Google Inc." &&
        isOpera === false &&
        isIEedge === false
    ) {
        // is Google Chrome
        return true;
    } else { 
        // not Google Chrome 
        return false;
    }
}

function checkIsIOS() {
    var userAgent = window.navigator.userAgent;

    if (userAgent.match(/iPad/i) || userAgent.match(/iPhone/i)) {
        // iPad or iPhone
        return true
    }
    else {
        // Anything else
        return false;
    }
}

function checkIsSafari() {
    var userAgent = window.navigator.userAgent;

    if (userAgent.match(/Safari/i)) {
        // Safari
        return true
    }
    else {
        // Anything else
        return false;
    }
}

function checkIsFirefox() {
    var userAgent = window.navigator.userAgent;

    if (userAgent.match(/Firefox/i)) {
        // Firefox
        return true
    }
    else {
        // Anything else
        return false;
    }
}

function setFlagIsNotChrome() {
    let bodyEl = document.querySelector('body');
    if(!bodyEl) return;
    bodyEl.classList.add('is-not-chrome');
}

function setFlagIsChrome() {
    let bodyEl = document.querySelector('body');
    if(!bodyEl) return;
    bodyEl.classList.add('is-chrome');
}

function setFlagIsIOS() {
    let bodyEl = document.querySelector('body');
    if(!bodyEl) return;
    bodyEl.classList.add('is-ios');
}

function setFlagIsSafari() {
    let bodyEl = document.querySelector('body');
    if(!bodyEl) return;
    bodyEl.classList.add('is-safari');
}

function setFlagIsFirefox() {
    let bodyEl = document.querySelector('body');
    if(!bodyEl) return;
    bodyEl.classList.add('is-firefox');
}

document.addEventListener('DOMContentLoaded', function() {
    updatePositionOnTextOnChrome();
});